import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { EligibilityArea } from '../../../types/apiModels'
import { MonitoringAccordion } from '../MonitoringAccordion'
import { formattedHectaresArea } from '../utils'

interface EligibilityAreaItemProps {
  area: EligibilityArea
}

export const EligibilityAreaItem: React.FC<EligibilityAreaItemProps> = ({ area }) => {
  const { properties } = area
  const { label, description, color, id } = properties

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ alignItems: 'center', py: 2, width: '100%', justifyContent: 'space-between' }}
    >
      {/* Vertical Color Band */}
      <Box
        sx={{
          bgcolor: color,
          background: color,
          flexShrink: 0,
          height: '100%',
          width: 10,
        }}
      />

      {/* Content */}
      <Stack
        alignItems="center"
        direction="row"
        spacing={2}
        sx={{ flexGrow: 1, p: 1.5, width: '100%' }}
      >
        <MonitoringAccordion.Item.Check itemId={id} />

        <Box sx={{ flexGrow: 1 }}>
          <Typography fontWeight={600} lineHeight={1.2} variant="body2">
            {label}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            {description}
          </Typography>
        </Box>

        <Typography fontWeight={600} variant="body2">
          {formattedHectaresArea(area)}
        </Typography>
      </Stack>
    </Stack>
  )
}
